import React from 'react'
import {
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Switch,
  Typography,
} from 'antd'
import { DatePickerWithMask, UIFormSection, UIInfoBanner, UISwitchField } from '../../../../components'
import { timeZones } from '../../../../redux/constants'

const URL_CONEXAO = process.env.REACT_APP_API_EMPRESA_URL
  ? `${process.env.REACT_APP_API_EMPRESA_URL}/api/v1/integracao/idface`
  : null

const GERENCIADOR_FIELDS = [
  'ultimo_nsr',
  'configuracao_idface[ip]',
  'configuracao_idface[porta_tcp_ip]',
  'configuracao_idface[gateway]',
  'configuracao_idface[mascara_sub_rede]',
  'configuracao_idface[usuario]',
  'configuracao_idface[senha]',
  'configuracao_idface[tipo_documento]',
]

const IDFace = ({ communicationType, item, handleClearDateTime, handleClearTimeZones, form }) => {
  const [atualizar, setAtualizar] = React.useState(
    Boolean(parseInt(item.updateDateHour))
  )

  const [enviarFacial, setEnviarFacial] = React.useState(
    Boolean(parseInt(item.enableFacialBiometrics))
  )

  const [metodoIntegracao, setMetodoIntegracao] = React.useState(
    item?.metodoIntegracao || 'gerenciador'
  )

  const savedGerenciadorRef = React.useRef({})

  React.useEffect(() => {
    setMetodoIntegracao(item?.metodoIntegracao || 'gerenciador')
    savedGerenciadorRef.current = {}
  }, [item?.metodoIntegracao])

  const isPush = metodoIntegracao === 'push'

  const handleMetodoChange = (value) => {
    if (value === 'push' && form) {
      const snapshot = {}
      GERENCIADOR_FIELDS.forEach((field) => {
        snapshot[field] = form.getFieldValue(field)
      })
      savedGerenciadorRef.current = snapshot
    } else if (value === 'gerenciador' && form && Object.keys(savedGerenciadorRef.current).length) {
      form.setFieldsValue(savedGerenciadorRef.current)
    }
    setMetodoIntegracao(value)
  }

  const handleEnableFacialBiometrics = (checked) => {
    if (checked) {
      Modal.info({
        title: 'Recomendações para a foto!',
        content: (
          <div style={{ textAlign: 'justify' }}>
            <p>Para o cadastro facial ocorrer com sucesso a foto deve seguir as seguintes recomendações:</p>
            <ul>
              <li>A foto deve conter uma face que não esteja nem muito próxima nem muito distante. A região da face deve estar totalmente contida na foto, sendo mantida uma pequena margem em relação a cada um dos lados.</li>
              <li>A região da face deve ocupar o centro da imagem tanto na direção vertical quanto na horizontal.</li>
              <li>A pessoa na foto deve estar com a face voltada para a câmera, olhando para a frente.</li>
              <li>A região da face deve estar nítida e bem iluminada.</li>
            </ul>
          </div>
        ),
        maskClosable: false,
        keyboard: false,
        closable: false,
        width: 600,
      })
    }
  }

  return (
    <div>
      <UIFormSection
        icon={<i className="fal fa-signal-stream" />}
        title="Dados de comunicação"
        description="Informe os dados necessários para que o equipamento possa se comunicar com o sistema."
      >
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="numero_serial_rep"
              label="Número de série"
              hasFeedback
              rules={[{ required: true, message: "Campo obrigatório." }]}
            >
              <Input placeholder="Número de série" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="configuracao_idface[metodo_integracao]"
              label="Método de integração"
              initialValue="gerenciador"
              rules={[{ required: true, message: 'Campo obrigatório.' }]}
            >
              <Select onChange={handleMetodoChange}>
                <Select.Option value="gerenciador">Gerenciador</Select.Option>
                <Select.Option value="push">Push</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          {!isPush && (
            <Col xs={24} md={12}>
              <Form.Item
                name="ultimo_nsr"
                label="Último NSR no equipamento"
                hasFeedback
                rules={[{ required: true, message: 'Campo obrigatório.' }]}
              >
                <InputNumber
                  type="number"
                  placeholder="Último NSR no equipamento"
                  min="1"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
          )}
          <Col xs={24} md={12}>
            <Form.Item
              name="ultimo_nsr_rep_p"
              label="Último NSR REP-P"
              hasFeedback
            >
              <InputNumber
                type="number"
                placeholder="Último NSR"
                disabled
                min="1"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} style={!isPush ? { display: 'none' } : {}}>
            <DatePickerWithMask
              label="Importar registros a partir de"
              name="configuracao_idface[sincronizar_a_partir_de]"
              showTime={true}
              required={isPush}
            />
          </Col>
        </Row>
        {isPush && URL_CONEXAO && (
          <Row gutter={16}>
            <Col xs={24}>
              <div>
                <p style={{ fontWeight: 'bold' }}>URL de Conexão</p>
                <Typography.Text copyable>{URL_CONEXAO}</Typography.Text>
              </div>
            </Col>
          </Row>
        )}
        {!isPush && (
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                name="configuracao_idface[ip]"
                label="IP"
                hasFeedback
                rules={[
                  {
                    required: communicationType === "tcp_ip",
                    message: "Campo obrigatório.",
                  },
                ]}
              >
                <Input placeholder="IP" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="configuracao_idface[porta_tcp_ip]"
                label="Porta TCP/IP"
                hasFeedback
                rules={[
                  {
                    required: communicationType === "tcp_ip",
                    message: "Campo obrigatório.",
                  },
                ]}
              >
                <InputNumber
                  type="number"
                  placeholder="Porta TCP/IP"
                  min="1"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="configuracao_idface[gateway]" label="Gateway">
                <Input placeholder="Gateway" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="configuracao_idface[mascara_sub_rede]"
                label="Máscara de sub rede"
              >
                <Input placeholder="Máscara de sub rede" />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="configuracao_idface[usuario]"
                label="Usuário"
                hasFeedback
                rules={[
                  {
                    required: communicationType === "tcp_ip",
                    message: "Campo obrigatório.",
                  },
                ]}
              >
                <Input placeholder="Usuário" />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="configuracao_idface[senha]"
                label="Senha"
                hasFeedback
                rules={[
                  {
                    required: communicationType === "tcp_ip",
                    message: "Campo obrigatório.",
                  },
                ]}
              >
                <Input
                  type="password"
                  placeholder="Senha"
                  autoComplete="new-password"
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={24}>
              <Form.Item
                name="configuracao_idface[tipo_documento]"
                label="Tipo de comunicação"
                hasFeedback
                rules={[{ required: communicationType !== 'pendrive', message: 'Campo obrigatório.' }]}
              >
                <Select placeholder="Selecione o tipo de comunicação">
                  <Select.Option value="cpf">CPF</Select.Option>
                  <Select.Option value="pis">PIS/PASEP</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        )}

      </UIFormSection>
      <UIFormSection
        icon={<i className="fal fa-cog" />}
        title="Outros"
        description="Configurações adicionais do equipamento."
      >
        <Row gutter={16}>
          <Col xs={24} md={24}>
            <UISwitchField
              icon={<i className="fal fa-camera" />}
              title="Utilizar avatar do funcionário para cadastro de biometria facial"
              description="Permite utilizar a foto do funcionário como referência na biometria facial."
            >
              <Form.Item
                name="configuracao_idface[enviar_avatar_facial]"
                valuePropName="checked"
                noStyle
              >
                <Switch
                  value={enviarFacial}
                  checked={enviarFacial}
                  onChange={(value) => {
                    setEnviarFacial(!enviarFacial);
                    handleEnableFacialBiometrics(value);
                  }}
                />
              </Form.Item>
            </UISwitchField>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginTop: 16 }}>
          <Col xs={24} md={12}>
            <UISwitchField
              icon={<i className="fal fa-calendar-alt" />}
              title="Atualizar data e hora do relógio"
              description="Sincroniza automaticamente a data e hora do equipamento."
            >
              <Form.Item
                name="configuracao_idface[atualizar_data_hora]"
                valuePropName="checked"
                noStyle
              >
                <Switch
                  value={atualizar}
                  checked={atualizar}
                  onChange={() => {
                    setAtualizar(!atualizar);
                    handleClearDateTime();
                  }}
                />
              </Form.Item>
            </UISwitchField>
          </Col>
          <Col xs={24} md={12}>
            <DatePickerWithMask
              label="Data e hora"
              name="configuracao_idface[data_hora]"
              showTime={true}
              disabled={!atualizar}
            />
          </Col>

          <Col xs={24} md={24}>
            <Form.Item
              name="configuracao_idface[fuso_horario]"
              label="Fuso horário"
              hasFeedback
              rules={[{ required: communicationType !== 'pendrive', message: "Campo obrigatório." }]}
            >
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (typeof option.children === "string"
                    ? option.children
                    : option.children.props.children
                  )
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                allowClear
                placeholder="Selecione o fuso horário"
                showSearch
              >
                {timeZones.map((item) => (
                  <Select.Option value={item.value}>{item.label}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </UIFormSection>
      <UIInfoBanner
        icon={<i className="fal fa-exclamation-circle" />}
        title="Importante"
        description="Verifique se todas as informações estão corretas para garantir a comunicação adequada entre o equipamento e o sistema."
      />
    </div>
  );
}

export default IDFace
